import { motion } from "framer-motion";
import { useNow, useStats } from "../hooks/useStats";
import { useT, usePrefs } from "../lib/prefs";
import { formatClassAt } from "../lib/classDate";

const pad = (n) => String(n).padStart(2, "0");

const Unit = ({ v, l, testid }) => (
  <div className="flex-1 glass rounded-2xl py-3 sm:py-4 text-center">
    <div className="font-display font-black text-3xl sm:text-4xl tabular-nums text-white" data-testid={testid}>{pad(v)}</div>
    <div className="font-mono text-[11px] sm:text-xs tracking-[0.2em] text-violet-200 mt-1">{l}</div>
  </div>
);

export const Countdown = () => {
  const t = useT();
  const { lang } = usePrefs();
  const now = useNow();
  const stats = useStats();
  const classAt = stats?.class_at ? new Date(stats.class_at).getTime() : NaN;
  if (Number.isNaN(classAt)) return <div data-testid="countdown" className="h-28" />;
  const diff = Math.max(0, classAt - now);
  const live = diff === 0;
  const s = Math.floor(diff / 1000);

  return (
    <div data-testid="countdown">
      <div className="flex items-center justify-between font-mono text-xs tracking-[0.2em] text-violet-200 mb-3">
        <span>{t.classDate}</span>
        <span className="text-white text-sm sm:text-base font-semibold" data-testid="class-date-label">{formatClassAt(stats.class_at, lang)}</span>
      </div>
      {live ? (
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="glass rounded-2xl py-5 text-center font-display font-black uppercase text-xl sm:text-2xl text-gradient"
          data-testid="class-live-banner"
        >
          <span className="inline-block w-2.5 h-2.5 rounded-full bg-pink-400 animate-pulse mr-3 align-middle" />
          {t.live}
        </motion.div>
      ) : (
        <div className="flex gap-2 sm:gap-3">
          <Unit v={Math.floor(s / 86400)} l={t.units[0]} testid="countdown-days" />
          <Unit v={Math.floor((s % 86400) / 3600)} l={t.units[1]} testid="countdown-hours" />
          <Unit v={Math.floor((s % 3600) / 60)} l={t.units[2]} testid="countdown-minutes" />
          <Unit v={s % 60} l={t.units[3]} testid="countdown-seconds" />
        </div>
      )}
    </div>
  );
};
